import { render, staticRenderFns } from "./games-select-advanced-options.vue?vue&type=template&id=4072b790&scoped=true&"
import script from "./games-select-advanced-options.vue?vue&type=script&lang=js&"
export * from "./games-select-advanced-options.vue?vue&type=script&lang=js&"
import style0 from "./games-select-advanced-options.vue?vue&type=style&index=0&id=4072b790&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072b790",
  null
  
)

export default component.exports